<!-- <app-slider></app-slider> -->
<!-- <div id="middle-header">
    <div class="row d-flex">
        <div class=" col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-7 text-xs-center">
            <div id="school-logo">
                <img src="/assets/img/logo/3.png" alt="School Logo" class="img-fluid border-0">
            </div>
            
            
        </div>
        <div class=" col-sm-6 col-md-6 col-lg-6 col-xl-5  d-none d-sm-block">
            <div class="row d-flex" id="loc">
                <div class="col-lg-1 col-md-1 col-sm-1" >
                    <div id="logo" class="text-center"><i class="fa fa-phone"></i></div >
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3" id="phone">
                    <h4>Call Now</h4>
                    <p class="mb-1">8059700244</p>
                </div>
              
                <div class="col-lg-6 col-md-6 col-sm-6" id="location">
                    <button class="btn payButton mt-lg-2" data-toggle="modal" data-target="#payModal">Click Here To Pay</button>
                    
                </div>
            </div>
            
        </div>
        <div class="d-block d-sm-none mx-auto mb-2">
            <button class="btn payButton mt-lg-2" data-toggle="modal" data-target="#payModal">Click Here To Pay</button>
        </div>
    </div>

</div> -->

<!-- <div id="menu-bar" class="sticky-top">
    <nav class="navbar navbar-expand-xl ">
        <button class="navbar-toggler"
            data-toggle="collapse"
            data-target="#menu">
            <span class="navbar-toggler-icon" style="color: var(--white);"><i class="fas fa-bars"></i></span>
        </button>
        <div class="collapse navbar-collapse" id="menu" >
            <ul class="navbar-nav mx-auto text-center">
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
                    <a routerLink="/" class="nav-link " data-toggle="collapse" data-target="#menu">Home</a>
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
                    <a routerLink="/Mandatory-Public-Disclosure" class="nav-link " data-toggle="collapse" data-target="#menu">Mandatory Public Disclosure</a>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a href="" class="nav-link dropdown-toggle" id="#menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MPPS Family</a>
                    
                    <ul class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                       
                       <li class="dropdown-submenu dropright"> 
                           <a class="nav-link dropdown-toggle " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">>> Accomplishments</a>
                           <div class="dropdown-menu submenu text-sm-center text-xl-left" aria-labelledby="menu">
                            <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                            routerLink="/accomplishment/co">>> co scholastic</a>
                            <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                            routerLink="/accomplishment/games">>> Games and sports</a>
                            <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                            routerLink="/accomplishment/cultural">>> Cultural</a>
                        </div>
                        </li>
                        <li class="dropdown-submenu dropright"> 
                            <a class="nav-link dropdown-toggle " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">>> Faculty</a>
                            <div class="dropdown-menu submenu text-sm-center text-xl-left" aria-labelledby="menu">
                             <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                             routerLink="/faculty/list">>>  Faculty List</a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/faculty/workshop">>> Workshop</a>
                         </div>
                         </li>

                         <li class="dropdown-submenu dropright"> 
                            <a class="nav-link dropdown-toggle " data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">>> Campus</a>
                            <div class="dropdown-menu submenu text-sm-center text-xl-left" aria-labelledby="menu">
                             <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/administrative">>> Administrative Block</a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/academic">>> Academic Block </a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/music">>> Music and art  </a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/labs">>> Laboratories </a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/ground">>> Ground </a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/transport">>> Transport </a>
                             <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                             routerLink="/campus/infrastructure">>> Infrastructure Type</a>
                         </div>
                         </li>
                       
                    </ul>
                </li>
                
               
                
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a href="" class="nav-link dropdown-toggle" id="#menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Glimpses</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                        routerLink="/glimpses/magazine">>> School magazine</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a href="" class="nav-link dropdown-toggle" id="#menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Achievements</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item" data-toggle="collapse" data-target="#menu" 
                        routerLink="/achievements/cbse">>> CBSE result</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/achievements/exemplary">>> Exemplary performances</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/achievements/awards">>> Awards and scholarships</a>
                    </div>
                </li>
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a href="" class="nav-link dropdown-toggle" id="#menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Admissions</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-toggle="modal" data-target="#myModal">>> Registration Form</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/message">>> Principal's message to parents</a>
                        <a class="dropdown-item" data-toggle="collapse" data-target="#menu"
                        routerLink="/admission/process">>> Admission Procedure</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/entrance-syllabus">>>Entrance Test Syllabus</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/library">>> Library and eBooks</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/hours">>> school hours</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/houses">>> School houses</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/uniform">>> School Uniform</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/fee">>> Fee Structure for Sec 7</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" 
                        routerLink="/admission/entrance-result">>>Entrance Test Result</a>
                    </div>
                </li>
              
                <li class="nav-item dropdown" routerLinkActive="active">
                    <a routerLink="/gallery" class="nav-link " id="#menu"data-toggle="collapse" data-target="#menu" aria-haspopup="true" aria-expanded="false">Gallery</a>
                    
                </li>
                <li class="nav-item dropdown e ml-4" >
                    <a href="" class="nav-link dropdown-toggle border border-white" id="#menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MPPS Connect</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu">>> Parent Login</a>
                        <a class="dropdown-item" data-toggle="collapse" data-target="#menu" >>> Student login</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" >>> ERP login</a>
                        <a class="dropdown-item" data-toggle="modal" data-target="#payModal" >>> online Fee Payment</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" >>> Alumni</a>
                        <a class="dropdown-item " data-toggle="collapse" data-target="#menu" >>> School map blueprint</a>
                    </div>
                </li>
  
            </ul>
        </div>
    </nav>
</div> -->

<!-- As a link -->
<div id="menu-bar" class="fixed-top">
    <nav class="navbar bg-light py-0">
        <div class="container-fluid">
          <a class="navbar-brand text-center pt-0" routerLink="/"><img src="/assets/img/logo/4.png" alt="Logo" class="img-fluid mt-3"></a>
          <div class="ms-auto menu-container">
            <button class="btn border-0 text-white menu-button" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" (click)="hideMenuBar()">
                <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 6C8 7.10457 7.10457 8 6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6Z"
                  fill="currentColor"
                />
                <path
                  d="M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z"
                  fill="currentColor"
                />
                <path
                  d="M6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20Z"
                  fill="currentColor"
                />
                <path
                  d="M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z"
                  fill="currentColor"
                />
                <path
                  d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
                  fill="currentColor"
                />
                <path
                  d="M14 18C14 19.1046 13.1046 20 12 20C10.8954 20 10 19.1046 10 18C10 16.8954 10.8954 16 12 16C13.1046 16 14 16.8954 14 18Z"
                  fill="currentColor"
                />
                <path
                  d="M18 8C19.1046 8 20 7.10457 20 6C20 4.89543 19.1046 4 18 4C16.8954 4 16 4.89543 16 6C16 7.10457 16.8954 8 18 8Z"
                  fill="currentColor"
                />
                <path
                  d="M20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z"
                  fill="currentColor"
                />
                <path
                  d="M18 20C19.1046 20 20 19.1046 20 18C20 16.8954 19.1046 16 18 16C16.8954 16 16 16.8954 16 18C16 19.1046 16.8954 20 18 20Z"
                  fill="currentColor"
                />
              </svg>Menu</button>
           
          </div>
        </div>
      </nav>
</div>
<div class="offcanvas offcanvas-end text-white"  tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel">Maharana Pratap Public School</h5>
        <button type="button" class="btn-close bg-white " data-bs-dismiss="offcanvas" aria-label="Close" (click)="showMenuBar()"></button>
    </div>
    <div class="offcanvas-body mt-5">
        <div>
            <div class="input-group mb-3">
                <input type="text" class="form-control" (keyup)="onSeachDropdownValue($event)" placeholder="Search"/>
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
            
            <div class="dropdown-selector ps-4">
              <div class="dropdown-selector-option" *ngFor="let option of searchedOptions" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" [routerLink]="[option.route]">{{option.name}}</div>
            </div>
          </div>
        <ul class="navbar-nav ms-4">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" routerLink="/" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" >Home</a>
            </li>
            <li class="nav-item">
              <a routerLink="/Mandatory-Public-Disclosure" class="nav-link" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()">Mandatory Public Disclosure</a>
            </li>
            <!-- <li class="nav-item" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Accomplishments</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" 
                            routerLink="/accomplishment/co"> co scholastic</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/accomplishment/games"> Games and sports</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/accomplishment/cultural">Cultural
                        </a>
                </div>
            </li> -->

            <!-- <li class="nav-item" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Faculty</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/faculty/list"> Faculty List</a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/faculty/workshop">Workshop</a>
                </div>
            </li> -->
            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">We MPPIANS</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" 
                        routerLink="/about-us/vision"> Mission & Vision</a>
                        <!-- data-bs-toggle="modal" data-bs-target="#myModal" -->
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/about-us/principal"> Principal's Message </a>
                    </div>
            </li>
            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Admissions</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openModal()"> Registration Form</a>
                        <!-- data-bs-toggle="modal" data-bs-target="#myModal" -->
                        <!-- <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/message"> Principal's message to parents</a> -->
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/process"> Admission Procedure</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/subjects"> Subjects offered in Class XI</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/entrance-syllabus">Entrance Test Syllabus</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/achievements/awards"> Awards and scholarships</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/library"> Library and eBooks</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/hours"> school hours</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/houses"> School houses</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/uniform"> School Uniform</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/fee"> Fee Structure</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/entrance-result">Entrance Test Result</a>
                    </div>
            </li>
            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Achievements</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/achievements/cbse"> CBSE result</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/achievements/exemplary"> Exemplary performances</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/achievements/awards"> Awards and scholarships</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" 
                            routerLink="/accomplishment/co"> co scholastic</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/accomplishment/games"> Games and sports</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/accomplishment/cultural">Cultural
                        </a>
                </div>
            </li>
            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Laboratories</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/labs/overview"> Overview</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/labs/physics"> Physics Lab</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/labs/chemistry"> Chemistry Labs</a>
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" 
                            routerLink="/labs/biology"> Biology Lab</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/labs/self-management"> Self Management</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/labs/computer">Computer Lab
                        </a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/labs/fine"> Art & Craft</a>
                            <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                            routerLink="/labs/math"> Mathematics</a>
                </div>
            </li>
            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Campus</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                    <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/administrative"> Administrative Block</a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/academic"> Academic Block </a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/music">Music and art  </a>
                    <!-- <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/labs">Laboratories </a> -->
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/ground">Ground </a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/transport">Transport </a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/campus/infrastructure">Infrastructure Type</a>
                </div>
            </li>
            

            <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Glimpses</a>
                
                <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                    <!-- <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    routerLink="/glimpses/magazine">School magazine</a> -->
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    [routerLink]="'/'" [fragment]="'events'">MPPS Speaks</a>
                    <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                    [routerLink]="'/'" [fragment]="'blogging'">Blogs</a>
                </div>
                
            </li>

         
            <!-- <li class="nav-item" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Admissions</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openModal()"> Registration Form</a>
                      
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/message"> Principal's message to parents</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/process"> Admission Procedure</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/entrance-syllabus">Entrance Test Syllabus</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/library"> Library and eBooks</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/hours"> school hours</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/houses"> School houses</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/uniform"> School Uniform</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/fee"> Fee Structure for Sec 7</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"
                        routerLink="/admission/entrance-result">Entrance Test Result</a>
                    </div>
            </li> -->
            <li class="nav-item">
                <a routerLink="/gallery" class="nav-link" data-bs-toggle="offcanvas"  data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()">Gallery</a>
              </li>
              <li class="nav-item dropdown-nav" routerLinkActive="active">
                <a href="" class="nav-link dropdown-toggle" id="#menu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">MPPS Connect</a>
                    <div class="dropdown-menu text-sm-center text-xl-left" aria-labelledby="menu">
                        <!-- <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()"> Parent Login</a>
                        <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" > Student login</a> -->
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openUrl('https://digitechstudent.digitechindia.co.in/')"> Web ERP login</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openUrl('https://play.google.com/store/apps/details?id=com.digital.technology')"> App ERP login</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openUrl('https://onlinefee.digitechindia.co.in/mppskurukshetra/')" > online Fee Payment</a>
                        <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="openUrl('https://data.odpay.in/odforms/form/MPPSAlumniRegistration/formperma/0gc8JbuEyWTWsD0zONSgGefNyMwKEvIe6DhNUPp6FHA')" > Alumni</a>
                        <!-- <a class="dropdown-item " data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()" > School map blueprint</a> -->
                    </div>
            </li> 
            <li class="nav-item">
                <a routerLink="/contact-us" class="nav-link" data-bs-toggle="offcanvas"  data-bs-target="#offcanvasWithBothOptions" (click)="showMenuBar()">Contact Us</a>
              </li>
        </ul>
    </div>
    </div>
<div id="payModal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Pay Now</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
         <a class="btn" href="https://onlinefee.digitechindia.co.in/mppskurukshetra/" target="_blank">MPPS Sector 7</a>
         <a class="btn ms-3" href="https://onlinefee.digitechindia.co.in/mppscskkr/" target="_blank">MPPS City</a>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
<!-- Modal -->
<!-- <div class="modal fade" id="contactModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="contactModal__Label">Contact Us</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)">
            <div class="modal-body">
                <label for="name" class="font-weight-bold h4"> Name</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-person-badge"></i>
                        </span>
                        </div>
                    
                    <input 
                    type="text" 
                    class="form-control"
                    id="name"
                    name="name"
                    placeholder="Name"
                    ngModel
                    required>
                </div>
                <label for="email" class="font-weight-bold h4">Email</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-envelope"></i>
                        </span>
                        </div>
                    
                    <input 
                    type="email" 
                    class="form-control"
                    id="email"
                    name="email"
                    placeholder="email"
                    ngModel
                    email
                    required>
                </div>
                <label for="phone" class="font-weight-bold h4">Phone Number</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-phone"></i>
                        </span>
                        </div>
                    
                    <input 
                    type="tel" 
                    class="form-control"
                    id="phone"
                    name="phone"
                    placeholder="phone number"
                    ngModel
                    minlength="10"
                    maxlength="10"
                    required
                    pattern="[6-9]{1}[0-9]{9}">
                </div>
                <label for="message" class="font-weight-bold h4">Message</label>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="bi bi-chat-left-dots"></i>
                        </span>
                        </div>
                    
                    <textarea 
                    class="form-control"
                    id="message"
                    placeholder="Message"
                    name="message"
                    rows="5"
                    ngModel
                    required></textarea>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button class="btn btn-primary hide-modal" type="submit"
                     [disabled]="!contactForm.valid" >Submit</button>
            </div>
        </form>
       
      </div>
    </div>
  </div> -->